import { asCostDate } from './period.js';
/** Every date in a period, inclusive start and **exclusive** end, by the calendar. */
export const datesIn = (period) => {
    const dates = [];
    const at = new Date(`${period.from}T00:00:00Z`);
    const end = new Date(`${period.to}T00:00:00Z`);
    while (at < end) {
        dates.push(asCostDate(at));
        at.setUTCDate(at.getUTCDate() + 1);
    }
    return dates;
};
/** How many days the period's month has — 28 to 31, the calendar's problem. */
export const daysInMonthOf = (period) => {
    const start = new Date(`${period.from}T00:00:00Z`);
    return new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 0)).getUTCDate();
};
/**
 * One point per finished day, summed across accounts, running total alongside.
 *
 * Days outside the period are ignored rather than trusted: a cached answer for
 * a wider window must not add a day the chart's axis does not have.
 */
export const cumulativeSeries = (period, accounts) => {
    const byDate = new Map();
    for (const date of datesIn(period))
        byDate.set(date, 0);
    for (const days of accounts) {
        for (const day of days) {
            const sofar = byDate.get(day.date);
            if (sofar !== undefined)
                byDate.set(day.date, sofar + day.amount);
        }
    }
    let running = 0;
    return [...byDate.entries()].map(([date, amount]) => {
        running += amount;
        return { date, amount, cumulative: running };
    });
};
/**
 * Where the month ends if it carries on as it has — a straight line, and
 * labelled as one wherever it is shown.
 *
 * Deliberately naive. Cost is lumpy (a monthly support charge on the first, a
 * large apply mid-month), so anything cleverer would look more authoritative
 * without being more right. `undefined` before any day has finished, because a
 * projection from nothing is not a projection.
 */
export const projectMonthEnd = (period, series) => {
    const last = series[series.length - 1];
    if (last === undefined)
        return undefined;
    const daysElapsed = series.length;
    const daysInMonth = daysInMonthOf(period);
    return {
        projected: (last.cumulative / daysElapsed) * daysInMonth,
        daysElapsed,
        daysInMonth,
    };
};
//# sourceMappingURL=series.js.map